export class FiltroRecapitoAnagrafeVO {
  tipoRecapito: string = "";
  indirizzo: string;
  descrizione: string;
  dug: string;
  numeroCivico: string;
  comune: string;
  indirizzoTelematico: string;
  idSoggetto: number;
  idRecapito: number;
}
